import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {Link, useNavigate, useSearchParams} from "react-router-dom";

import HubInputField from "../../components/inputType";

import { resetpasswordSchema } from "../../validation/resetPassword";
import useFetch from "../../hooks/useFetch";
import { APIEndpoints } from "../../types/apiTypes";
import { ResetPasswordAPISuccessResponseType } from "./types";
import { ToastContext } from "../../context/toastContext";
import { ToastTypes } from "../../types";
import {EuflexxaBanner} from "../../assets";
import ContactAndSafetyInfo from "../../components/contactAndSafetyInfo";
import {TextAlignProps} from "../../components/contactAndSafetyInfo/types";
import FooterText from "../../components/footerText";



const HubResetPassword: FC = (): JSX.Element => {
  const [resetToken, setResetToken] = useState<string>('');
  const [searchParams] = useSearchParams();

  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(resetpasswordSchema),
  });





  const { loading, data, error, removeErrorAndData, mutate } = useFetch<ResetPasswordAPISuccessResponseType>(APIEndpoints.USER_RESET_PASSWORD);

  useEffect(() => {
    const obj = new URLSearchParams(searchParams);
    setResetToken(obj.get('reset_password_token') || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      const { message } = data;
      showToast([message], ToastTypes.SUCCESS);
      navigate("/users/sign_in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const submitPassword = async (values: { password: string, confirmPassword: string }) => {
    if ((error && error.length > 0) || data) removeErrorAndData();
    mutate({ user: { reset_password_token: resetToken, ...values } });
  };

  return (
      <div className="container-fluid login-sec d-flex flex-fill flex-column justify-content-between overflow-auto">
          <div className="container d-flex flex-fill flex-column">
              <div className="card mt-2">
                  <div className="card-body p-2">
                      <div className="row">
                          <div className="col-12 col-md-6">
                              <img className="img-fluid login-banner" src={EuflexxaBanner} alt="Banner Info"/>
                          </div>
                          <div className="col-12 col-md-6">
                              <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_END} textColor="black"/>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="row flex-fill pt-2">
                  <div className="col-12 col-md-7"></div>

                  <div className="col-12 col-md-5">
                      <form onSubmit={handleSubmit(submitPassword)} className="card mt-4">
                          <div className="card-header">
                              <h1 className="mb-2 text-white fw-bold">Reset Your Password</h1>
                          </div>

                          <div className="card-body">
                              <Controller
                                  name="password"
                                  control={control}
                                  defaultValue=''
                                  render={({ field, fieldState: { error } }) => (
                                      <HubInputField
                                          inputId="password"
                                          isRowBased={false}
                                          isRequired={true}
                                          field={field}
                                          error={error}
                                          inputLabel="New Password"
                                          inputType="password"
                                      />
                                  )}
                              />

                              <Controller
                                  name="confirmPassword"
                                  control={control}
                                  defaultValue=''
                                  render={({ field, fieldState: { error } }) => (
                                      <HubInputField
                                          inputId="confirmPassword"
                                          isRowBased={false}
                                          isRequired={true}
                                          field={field}
                                          error={error}
                                          inputLabel="Confirm Password"
                                          inputType="password"
                                      />
                                  )}
                              />
                              <div className="mb-0 mt-3">
                                  <button disabled={loading} className="btn btn-primary" type="submit">
                                      <div className="row align-items-center px-1">
                                          {loading ? (
                                              <div className="spinner-border text-light col-3" role="status">
                                                  <span className="sr-only"></span>
                                              </div>
                                          ) : null}
                                          <p className="col-auto mb-0"> Reset Password </p>
                                      </div>
                                  </button>
                              </div>
                          </div>
                      </form>

                      <h1 className="fw-bold text-white pt-4 text-center">
                          Preferred HA on UHC Commercial Plans<sup>3</sup>
                      </h1>
                  </div>
              </div>
              <div className="text-white"><FooterText footerType="black"/></div>
          </div>
    </div>
  );
};

export default HubResetPassword;
